import { Link } from "react-router-dom";

const points = [
  { icon: "ri-tv-2-line", title: "多频道内容", desc: "电视剧、综艺、电影、动漫、纪录片，一站看个够。" },
  { icon: "ri-filter-3-line", title: "智能筛选", desc: "按类型、地区、年份、热度快速找到想看的内容。" },
  { icon: "ri-search-line", title: "便捷搜索", desc: "一键入词，影视与资讯结果同时呈现。" },
  { icon: "ri-newspaper-line", title: "资讯同步", desc: "追剧之余，第一时间了解最新娱乐动态。" },
];

export default function SiteIntro() {
  return (
    <section className="rounded-lg border border-background-200 bg-background-50 p-6 md:p-8">
      <div className="grid grid-cols-1 gap-8 lg:grid-cols-2 lg:items-center">
        <div>
          <span className="inline-flex items-center gap-1 rounded-full bg-primary-100 px-3 py-1 text-xs font-semibold text-primary-700">
            <i className="ri-mickey-fill" />
            关于平台
          </span>
          <h1 className="mt-3 font-heading text-2xl font-extrabold text-foreground-950 md:text-3xl">
            芒果tv 综合影视平台
          </h1>
          <p className="mt-3 text-sm leading-relaxed text-foreground-600">
            芒果tv 以清晰的频道分类、丰富的影视内容与实时娱乐资讯，为观众打造一个专业又活泼的观影门户。无论你是追剧爱好者、综艺粉丝还是电影影迷，都能在这里快速找到属于自己的那一部作品。
          </p>
          <p className="mt-3 text-xs leading-relaxed text-foreground-500">
            本站作品、演员、评分与资讯均为虚构或中性示例数据，播放功能仅为演示，不提供真实视频播放与下载。
          </p>
          <Link
            to="/about"
            className="mt-5 inline-flex items-center gap-2 rounded-md bg-primary-500 px-5 py-2.5 text-sm font-semibold text-background-50 hover:bg-primary-600 cursor-pointer whitespace-nowrap"
          >
            了解更多
            <i className="ri-arrow-right-line" />
          </Link>
        </div>
        <div className="grid grid-cols-1 gap-3 sm:grid-cols-2">
          {points.map((p) => (
            <div key={p.title} className="rounded-lg bg-background-100 p-4">
              <span className="flex h-10 w-10 items-center justify-center rounded-md bg-accent-100 text-accent-600">
                <i className={`${p.icon} text-xl`} />
              </span>
              <h3 className="mt-3 font-heading text-sm font-semibold text-foreground-950">
                {p.title}
              </h3>
              <p className="mt-1 text-xs leading-relaxed text-foreground-500">{p.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}